// extracted by mini-css-extract-plugin
export default {"download_releases":"DownloadReleases_download_releases__dTQ2k","download_table":"DownloadReleases_download_table__3d5SH"};